module.exports = __webpack_public_path__ + "9e78fc6c420f19c4aee3be33541e4394.png";